import React, { Component } from "react";
import "./App.css";
import { Route, Switch } from "react-router-dom";
import HomePage from "./views/home";
import AboutPage from "./views/about";
import ContactUs from "./views/contact-us";
import SiteHead from "./shared/components/header";
import ProductsPage from "./views/products";
import Footer from "./shared/components/footer";
import Ebips from "./views/ebips";
import PrivacyPolicy from "./views/policies/privacy-policy";
import CookiePolicy from "./views/policies/cookie-policy";
import PrivacyNotice from "./views/policies/privacy-notice";
import CustomerAwarenessPolicy from "./views/policies/customer-awareness-policy";

const styles = {
  root: {
    display: "flex",
    minHeight: "100vh",
    flexDirection: "column",
  },
};
class App extends Component {
  constructor(props) {
    super(props);
    this.state = { navMini: false };
  }

  toggleNav = (e) => {
    e.preventDefault();
    this.setState({ navMini: !this.state.navMini });
  };
  hideNav = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ navMini: false });
  };

  render() {
    let navMini = this.state.navMini;
    return (
      <div className="app-wrapper">
        {/*<Nav mini={navMini} toggleNav={this.toggleNav}/>*/}
        <div
          className={`content-con ${navMini ? "full" : ""}`}
          style={styles.root}
        >
          {/* drop shadow for mobile nav triggering */}
          <div
            className="menu-dropshadow"
            style={{ display: navMini ? "block" : "none" }}
            onClick={this.hideNav}
          >
            &nbsp;
          </div>
          <SiteHead toggleNav={this.toggleNav} />
          <div>
            <Switch>
              <Route exact path="/" component={HomePage} />
              <Route component={ProductsPage} path="/products" />
              <Route component={AboutPage} path="/about" />
              <Route exact path="/contact-us" component={ContactUs} />
              <Route exact path="/privacy-policy" component={PrivacyPolicy} />
              <Route exact path="/privacy-notice" component={PrivacyNotice} />
              <Route exact path="/cookie-policy" component={CookiePolicy} />
              <Route
                exact
                path="/customer-awareness-policy"
                component={CustomerAwarenessPolicy}
              />
              <Route
                exact
                path="/ebips"
                render={(props) => <Ebips {...props} />}
              />
            </Switch>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js